import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, CanActivateChildFn } from '@angular/router';

import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AccountService } from '../services/account.service';
import { CurrentUserService } from '../services/current-user.service';
import { AccessEventsService } from '../services/access-events.service';

export const authorizationGuard: CanActivateChildFn = (route) => {
  const accessEventsService = inject(AccessEventsService);
  const router = inject(Router);
  const currentUserService = inject(CurrentUserService);

  if (!currentUserService.currentUser) {
    return inject(AccountService)
      .getCurrentUserInfo()
      .pipe(
        map((currentUserData) => {
          currentUserService.currentUser = currentUserData;
          return isCurrentUserAuthorized(route) || router.parseUrl('/');
        }),
        catchError(() => {
          accessEventsService.logout();
          return of(router.parseUrl('/login'));
        }),
      );
  }

  return isCurrentUserAuthorized(route) || router.parseUrl('/');
};

const isCurrentUserAuthorized = (route: ActivatedRouteSnapshot): boolean => {
  return !route.data['permit'] || inject(CurrentUserService).isAccessAllowedWithPermit(route.data['permit']);
};
